<template>
    <div class="text-box">
        <div class="title-bar">
            <div class="title">{{ title }}{{ extName }}</div>
        </div>

        <div v-show="!isLoading && !isError" ref="contentContainer" class="content-container">
            <div class="content-box">
                <div v-if="isSourceCode" ref="codeBox" class="content">
                    <!-- 
                        这里遇到一个神奇的现象，如果不采用 v-if 标签消除然后创建这个元素，
                        会有一个现象，就是首次设置 content，然后用 Prism 刷掉之后，
                        再次修改 content 属性就无法更新界面了。
                        怀疑是 Prism 在处理代码的过程中影响到了 Vue 的监控
                        所以把 Ref 向上提一层，利用 content 的长度来删除这个节点，然后再显示这个节点
                        就可以正常工作了。
                     -->
                    <pre v-if="content && content.length > 0"><code :class="codeClass">{{ content }}</code></pre>
                </div>
                <!-- 文本 -->
                <div v-if="!isSourceCode && isPlainText" class="content" v-html="content"></div>
            </div>
        </div>
        <div v-if="isError" class="error-box">
            加载失败
        </div>
        <div v-if="isLoading" class="loading-box">
            <img src="../assets/image/loading.png" alt="" class="loading-img">
        </div>
    </div>    
</template>

<script type="text/javascript">
import Vue from 'vue';
import tool from '../assets/scripts/tool.js';

import Prism from 'prismjs';

export default {
    props: {
        isLock: {
            type: Boolean,
            default: false
        },
        currentShow: {
            type: String,
            default: ''
        },

        hwFilesData: {
            type: Object,
            default: null
        }
    },

    data: function() {
        return {
            id: null,
            title: null,
            extName: null,
            mimeType: null,
            url: null,
            componentId: null,
            content: 'this is the test content',
            isLoading: true,
            isError: false,
            codeClass: '',
            supportedEventNames: [
                'resource.show',
                'common.moveJoystick'
            ],
            isText: true,
        };
    },

    computed: {
        isPlainText: function() {
            return this.mimeType && this.mimeType.toLowerCase() === 'text/plain';
        },

        isSourceCode: function() {
            return tool.getCodeLang(this.extName) != null;
        }
    },

    created: function() {
        if (this.isLock) return;
        if (this.currentShow === 'hw-1') {
            let data = this.hwFilesData.data;
            data.id = this.hwFilesData.data.relationId;
            console.log(data);
            this.$nextTick(() => {
                this.showFile(data);
            });
            
        }
    },

    mounted: function() {
        this.componentId = this.$attrs.id;
        window.addEventListener('message', this.windowMessageHandler);
    },

    destroyed: function() {
        window.removeEventListener('message', this.windowMessageHandler);
    },

    watch: {
        currentShow: function(val,oldVal) {
            if (val !== this.componentId && oldVal === this.componentId) {
                this.$refs.contentContainer.scrollTop = 0;
            };
        }
    },

    methods: {
        windowMessageHandler: function(e) {
            let msg = e.data;

            if (!msg.eventName) return;
            if (this.supportedEventNames.indexOf(msg.eventName) === -1) return;

            let msgData = msg.data;
            
            if (this.isLock && this.componentId === this.currentShow) return;

            switch (msg.eventName) {
                case 'resource.show':
                    this.showFile(msgData);
                    break;
                case 'common.moveJoystick':
                    this.moveJoystick(msgData);
                    break;
                default:
                    // statements_def
                    break;
            }
        },

        showFile: function(msgData) {
            if ( ! msgData || ! msgData.id) return;
            this.id = msgData.id;
            if (! msgData.url) {
                this.isError = true;
                return;
            }
            this.title = msgData.name;
            this.url = msgData.url;
            this.mimeType = msgData.mimeType;
            this.extName = msgData.extName;
            
            if (! this.isPlainText && ! this.isSourceCode) return;

            this.isError = false;
            this.isLoading = true;
            this.content = null;
            this.$http.get(msgData.url)
                .then(resp => {
                    let content = resp.data;
                    let lang = tool.getCodeLang(this.extName);
                    if (! lang) {
                        this.codeClass = '';
                        this.content = tool.htmlspecialchars(content);
                    } else {
                        this.codeClass = 'lang-' + lang;
                        this.content = content;
                        Vue.nextTick(() => {
                            Prism.highlightAllUnder(this.$refs.codeBox);
                            this.$refs.contentContainer.scrollTop = 0;
                        });
                    }
                    this.isLoading = false;
                })
                .catch(err => {
                    this.isError = true;
                });
        },

        moveJoystick: function(msgData) {
            let contentContainer = this.$refs.contentContainer;
            let direction = msgData.direction;
            if (direction === 'LEFT') return;
            if (direction === 'RIGHT') return;
            if (direction === 'UP') contentContainer.scrollTop -= 40;
            if (direction === 'DOWN') contentContainer.scrollTop += 40;
            
        },
    }
};
</script>

<style scoped>
    .text-box {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    .title-bar {
        height: 40px;
        padding: 20px 40px 20px 40px;
        background-color: #191919;
        text-align: center;
    }

    .title-bar .title {
        height: 40px;
        line-height: 40px;
        vertical-align: middle;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        text-align: center;
        font-size: 24px;
        color: #ffffff;
    }
    

    .content-container {
        position: absolute;
        top: 80px;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 40px;
        background-color: #252525;
        overflow: auto;
    }

    .content-box {
        border-radius: 8px;
        background-color: #f5f2f0;
        min-height: 100%;
        padding: 20px;
        box-sizing: border-box;
    }

    .content-box pre {
        border-radius: 8px;
    }

    .content {
        text-align: left;
        font-size: 1.5rem;
        line-height: 150%;
        color: black;
        overflow: hidden;
    }

    .error-box {
        font-size: 24px;
        color: #ffffff;
    }

    .loading-box {
        position: absolute;
        top: 80px;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .loading-box .loading-img {
        display: block;
        width: 100px;
        height: 100px;
        animation: load 1s;
        animation-timing-function: linear;
        animation-direction: reverse;
        animation-iteration-count: infinite;
    }

    @keyframes load {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(-360deg);
        }
    }
</style>